import Box from '@mui/material/Box';
import { Content } from '@tiptap/react';
import { RichTextReadOnly as MUIRichTextReadOnly } from 'mui-tiptap';

import './style.scss';
import useExtensions from './useExtension';

type RichTextProps = {
	content?: Content;
	placeholder?: string;
};

const RichText = ({ content, placeholder }: RichTextProps) => {
	const extensions = useExtensions({
		placeholder,
	});

	return (
		<Box className="pc-rich-text-readonly">
			<MUIRichTextReadOnly extensions={extensions} content={content} />
		</Box>
	);
};

export default RichText;
